import { Component, EventEmitter, OnInit,Inject } from '@angular/core';
import { CommonService } from '../common.service';
import { FormBuilder, Validators , FormGroup,FormControl} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationService } from '../notification.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
class ImageSnippet {
  pending: boolean = false;
  status: string = 'init';
  constructor(public src: string, public file: File) { }
}
@Component({
  selector: 'app-editvehicle',
  templateUrl: './editvehicle.component.html',
  styleUrls: ['./editvehicle.component.scss']
})
export class EditvehicleComponent implements OnInit {
  iseditveh=new EventEmitter()
  editvehform:FormGroup;
  id: any;
  SelectedValue:any;
  selected: ImageSnippet;
  selectedFile!: ImageSnippet;
  isedit=new EventEmitter()
  
  Submitted: boolean;
  image1:any
  editdata: any;
  constructor(private dialogRef: MatDialogRef<EditvehicleComponent>,@Inject(MAT_DIALOG_DATA) private data:any,public fb:FormBuilder,public service:CommonService,public dialog: MatDialog,private router: Router,private notification:NotificationService,private spinner:NgxSpinnerService) {
    this. editvehform= this.fb.group(
      {
          name: ['', [Validators.required ,
            Validators.minLength(1),
            Validators.maxLength(150),
            Validators.pattern(/^([A-Za-z]{1,150}|([A-Za-z]+\s[A-Za-z]))+$/)],],
            image: ['', [Validators.required]],
            numberOfSeats: [
              '',
              [Validators.required, Validators.min(1), Validators.max(1000)] 
            ]
          }
    )
   }

  ngOnInit(): void {
   





    this.id=this.data._id
    if (this.data) {
      if(this.data.type) { this.editvehform.controls.name.setValue(this.data.type) }
      if(this.data.numberOfSeats) { this.editvehform.controls.numberOfSeats.setValue(this.data.numberOfSeats) }
      this.image1=this.data.icon
      this.editvehform.controls.image.setValue(this.image1)
    }
    
  }
  editvehicle(valid){
    // this.spinner.show()
    this.id
    this.Submitted = true
    if(valid){
    let req ={
      "type": this.editvehform.controls['name'].value,
      "icon":this.image1,
      "numberOfSeats": this.editvehform.controls['numberOfSeats'].value,
      }
      this.spinner.show()
  this.service.editvehicle2(this.id,req).subscribe((data : any)=> {
    this.spinner.hide()
    if(data.statusCode == 200 && data.message == "Success"){
      this.notification.showSuccess(" Created successfully !",'')
      // this.getride();
      // this.editvehform?.reset();
      this.closeDialog()
      this.router.navigate(['/main/vehicletype'])
      this.iseditveh.emit(true)
      // this.Submitted=false;
      // this.image1=''
  
    }else{
    }
  }
  ,
  (error:HttpErrorResponse)=>{
    if(error.error.statusCode === 400){
     this.notification.showSuccess(error.error.message,'')
    }
    else{
      this.notification.showSuccess("Something went wrong",'')
  }
  
  }
  
  
  
  
  
  )
    }
  }
  closeDialog() {
    this.dialogRef.close();
  }
  get f() {
    return this.editvehform?.controls;
  }
  private onSuccess() {
    if (this.selectedFile) {
      this.selectedFile.pending = false;
      this.selectedFile.status = 'ok';
    }
  }
  private onError() {
    this.selectedFile.pending = false;
    this.selectedFile.status = 'fail';
    this.selectedFile.src = '';
  }
  process(imagedata: any) {
    const file: File = imagedata.files[0];
    const reader = new FileReader();
    // formControlName="RCIMAGE"
    this.editvehform.controls.image.setValue(file);
    // this.creatDriver.markAsDirty();
    reader.addEventListener('load', (event: any) => {
  
      this.selected= new ImageSnippet(event.target.result, file);
  
      this.selected.pending = true;
      this.service.uploadImage(this.selected.file).subscribe(
        (res: any) => {
          this.onSuccess();
          localStorage.setItem('Rcimage', JSON.stringify(res.data.location))
          this.image1 = res.data.location
        },
        (err: any) => {
          this.onError();
        })
    });
    reader.readAsDataURL(file);
  }
}
